module.exports = __webpack_public_path__ + "img/partner22.d5087957.png";